import { useNavigate, useParams } from 'react-router-dom'
import { IconChevronDown } from '@tabler/icons-react'
import {
  Burger,
  Button,
  Center,
  Container,
  Group,
  Menu,
  Modal,
  Stack,
} from '@mantine/core'
import { useDisclosure, useMediaQuery } from '@mantine/hooks'
import { useLogout } from '../api/user'
import { UserData } from '../models/user'
import classes from './Header.module.css'
import { ContactForm } from './ContactForm'

type Props = {
  userData: UserData
}

export function Header({ userData }: Props) {
  const [opened, { toggle }] = useDisclosure(false)
  const { mutate: logout, isPending: isLogoutPending } = useLogout()
  const isSmallScreen = useMediaQuery('(max-width: 640px)')
  const { marinaId } = useParams()
  const [
    openedContactForm,
    { open: openContactForm, close: closeContactForm },
  ] = useDisclosure(false)
  const navigate = useNavigate()

  const firstMarina = userData.marinas.length > 0 ? userData.marinas[0] : ''
  const currentMarina = userData.marinas.find(
    (m) => m.marina_id === parseInt(marinaId || '0', 10)
  )
  const label = `${userData.first_name} ${userData.last_name}${firstMarina ? ` (${firstMarina.name})` : ''}`
  const link = firstMarina ? `/marina/${firstMarina.marina_id}` : '#'

  const handleLogout = () => {
    logout()
  }

  return (
    <>
      <Modal
        opened={openedContactForm}
        onClose={closeContactForm}
        title={'Edit ' + (currentMarina?.name || '')}
        fullScreen={isSmallScreen}
        transitionProps={{ transition: 'fade', duration: 200 }}
      >
        <ContactForm marinaId={marinaId} onCancel={closeContactForm} />
      </Modal>
      <header className={classes.header}>
        <Container size="xl">
          <div className={classes.inner}>
            <span
              onClick={() => navigate('/')}
              style={{ cursor: 'pointer', fontWeight: 700, fontSize: '1.2rem' }}
            >
              Marina Availability
            </span>
            <Group gap={5} visibleFrom="sm">
              <Button variant="subtle" color="black" onClick={openContactForm}>
                Contact information
              </Button>
              <Menu
                trigger="hover"
                transitionProps={{ exitDuration: 0 }}
                position="bottom-end"
                offset={{ crossAxis: -10 }}
                withinPortal
              >
                <Menu.Target>
                  <a href={link} className={classes.link}>
                    <Center>
                      <span className={classes.linkLabel}>{label}</span>
                      <IconChevronDown size={14} stroke={1.5} />
                    </Center>
                  </a>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Item onClick={handleLogout} disabled={isLogoutPending}>
                    Sign out
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </Group>
            <Burger
              opened={opened}
              onClick={toggle}
              size="sm"
              hiddenFrom="sm"
            />
            {opened && (
              <div className={classes.mobileMenu}>
                <Stack align="center">
                  <a href={link} className={classes.link}>
                    <span className={classes.linkLabel}>{label}</span>
                  </a>
                  <Button
                    variant="outline"
                    color="red"
                    onClick={handleLogout}
                    loading={isLogoutPending}
                  >
                    Sign out
                  </Button>
                </Stack>
              </div>
            )}
          </div>
        </Container>
      </header>
    </>
  )
}
